import { render } from "./ImportarPDF.vue?vue&type=template&id=2b7f3748&scoped=true"
import script from "./ImportarPDF.vue?vue&type=script&lang=js"
export * from "./ImportarPDF.vue?vue&type=script&lang=js"

import "./ImportarPDF.vue?vue&type=style&index=0&id=2b7f3748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7f3748"]])

export default __exports__